module.exports = __webpack_public_path__ + "static/media/abbyweb.37fdf515.png";